import { Component, EventEmitter, Input, Output } from '@angular/core';
import { defaultTheme } from 'src/app/theme/theme';

@Component({
    selector: 'app-vertical-menu',
    templateUrl: './vertical-menu.component.html',
    styleUrls: ['./vertical-menu.component.scss'],
    standalone: false
})
export class VerticalMenuComponent {
  @Input()
  theme = defaultTheme;

  @Input()
  labels: string[];

  @Input()
  selectedIndex: number;

  @Output()
  clickMenu = new EventEmitter<number>();

  get selectedStyle() {
    return {
      'background-color': this.theme.primaryColor,
      color: '#fff'
    };
  }

  clickItem(index: number) {
    this.clickMenu.emit(index);
  }
}
